/**
 * Scan Pixel (AP12): o campo de cada PISTA do último enigma, da PISTA 1 à n. Dar a uma PISTA um
 * campo que já está em outra troca as duas, então a relação continua uma permutação dos campos.
 */
export function trocarCampo(campos: readonly number[], pista: number, campo: number): number[] {
    const nova = [...campos];
    const outra = nova.indexOf(campo);
    if (pista < 0 || pista >= nova.length || outra === -1) return nova;
    [nova[pista], nova[outra]] = [campo, nova[pista]];
    return nova;
}
